module.exports = __webpack_public_path__ + "images/5dbb9b5f9411e001f25af0be1ef0730d.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/memoji_left_2.png
// module id = 104
// module chunks = 0